import { IRecurly } from '@/@types'

const state: IRecurly = {
  recurlyPricing: null,
  recurlyToken: '',
  recurlyTokenActionId: '',
  recurlyTokenActionResult: '',
}

export default state
